"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useResizeObserver = void 0;
var _useIsomorphicLayoutEffect = require("./useIsomorphicLayoutEffect");
var _useLatest = require("./useLatest");
/**
 * Adapted from https://github.com/jaredLunde/react-hook/blob/3c813dab5b21e26f2c85e733314ca5c063c6bfce/packages/resize-observer/src/index.tsx
 */

var useResizeObserver = function useResizeObserver(_ref) {
  var _ref$active = _ref.active,
    active = _ref$active === void 0 ? true : _ref$active,
    target = _ref.target,
    onResize = _ref.onResize;
  var resizeObserver = getResizeObserver();
  var storedCallback = (0, _useLatest.useLatest)(onResize);
  (0, _useIsomorphicLayoutEffect.useIsomorphicLayoutEffect)(function () {
    if (!active || !resizeObserver) return;
    var didUnsubscribe = false;
    var targetEl = target && "current" in target ? target.current : target;
    if (!targetEl) return;
    var cb = function cb(entry, observer) {
      if (didUnsubscribe) return;
      storedCallback.current(entry, observer);
    };
    resizeObserver.subscribe(targetEl, cb);
    return function () {
      didUnsubscribe = true;
      resizeObserver.unsubscribe(targetEl, cb);
    };
  }, [target, resizeObserver, storedCallback]);
};
exports.useResizeObserver = useResizeObserver;
var createResizeObserver = function createResizeObserver() {
  if (typeof ResizeObserver === "undefined") return null;
  var ticking = false;
  var allEntries = [];
  var callbacks = new Map();
  var observer = new ResizeObserver(function (entries, obs) {
    allEntries = allEntries.concat(entries);
    if (!ticking) {
      window.requestAnimationFrame(function () {
        var triggered = new Set();
        var _loop = function _loop(i) {
          if (triggered.has(allEntries[i].target)) return "continue";
          triggered.add(allEntries[i].target);
          var cbs = callbacks.get(allEntries[i].target);
          cbs === null || cbs === void 0 ? void 0 : cbs.forEach(function (cb) {
            return cb(allEntries[i], obs);
          });
        };
        for (var i = 0; i < allEntries.length; i++) {
          var _ret = _loop(i);
          if (_ret === "continue") continue;
        }
        allEntries = [];
        ticking = false;
      });
    }
    ticking = true;
  });
  return {
    observer: observer,
    subscribe: function subscribe(target, callback) {
      var _callbacks$get;
      observer.observe(target);
      var cbs = (_callbacks$get = callbacks.get(target)) !== null && _callbacks$get !== void 0 ? _callbacks$get : [];
      cbs.push(callback);
      callbacks.set(target, cbs);
    },
    unsubscribe: function unsubscribe(target, callback) {
      var _callbacks$get2;
      var cbs = (_callbacks$get2 = callbacks.get(target)) !== null && _callbacks$get2 !== void 0 ? _callbacks$get2 : [];
      if (cbs.length === 1) {
        observer.unobserve(target);
        callbacks.delete(target);
        return;
      }
      var cbIndex = cbs.indexOf(callback);
      if (cbIndex !== -1) cbs.splice(cbIndex, 1);
      callbacks.set(target, cbs);
    }
  };
};
var _resizeObserver;
var getResizeObserver = function getResizeObserver() {
  return !_resizeObserver ? _resizeObserver = createResizeObserver() : _resizeObserver;
};
//# sourceMappingURL=useResizeObserver.js.map